import { useCallback } from 'react'
import { usePreference, setPreference } from '@fs/zion-preferences'

const PREFERENCE_KEY = 'shared-image-viewer.maintainZoomPan'

export default function useInitialMaintainZoom() {
  const initialMaintainZoomPreference = usePreference(PREFERENCE_KEY)
  const onToggleMaintainZoomPan = useCallback((newPreferenceValue) => {
    setPreference(PREFERENCE_KEY, newPreferenceValue)
  }, [])

  return {
    initialMaintainZoomPan: initialMaintainZoomPreference !== false, // true unless the user has explicitly set it to false
    onToggleMaintainZoomPan,
  }
}
